<template>
  <div class="content-wrap">
    <div class="main">
      <div class="container-fluid">
        <section id="main-content">
          <div class="row">
            <div class="col-lg-8 plotReport1">
              <div class="card">
                <div class="card-title pr d-flex" data-group="tableTitle">
                  <span>銷售管道</span>
                  <div style="display:inline-block;font-size:small">
                    <form class="form-inline">
                      <select
                        class="custom-select my-1 mr-sm-2"
                        id="page1CalendarSel"
                        v-if="weekAry.length > 0"
                        v-model="webExamSel"
                        @change="getWebExamData"
                      >
                        <option
                          :value="index"
                          v-for="(date,index) in weekAry"
                          :key="index"
                        >{{date[0]}}~{{date[date.length-1]}}</option>
                      </select>
                    </form>
                  </div>
                </div>
                <div class="card-body">
                  <canvas id="WebReportDataPlot"></canvas>
                </div>
              </div>
            </div>
            <div class="col-lg-4 plotReport2">
              <div id="convertStatGroup">
                <div class="card">
                  <div class="card-title pr d-flex" data-group="tableTitle">
                    <span>產品狀態</span>
                    <div style="display:inline-block;font-size:small">
                      <form class="form-inline">
                        <select
                          class="custom-select my-1 mr-sm-2"
                          id="page1CalendarSel2"
                          v-if="weekAry.length > 0"
                          v-model="convertSel"
                          @change="getConvertData"
                        >
                          <option
                            :value="index"
                            v-for="(date,index) in weekAry"
                            :key="index"
                          >{{date[0]}}~{{date[date.length-1]}}</option>
                        </select>
                      </form>
                    </div>
                  </div>
                  <div class="card-body">
                    <div style="width:80%;margin:auto">
                      <canvas id="convertStatPlot" style="margin:auto auto"></canvas>
                    </div>
                    <div class="table-responsive">
                      <table class="table table-borderless" v-if="convertData.length > 0">
                        <tr v-for="el in filterConvertData" :key="el.name">
                          <th>{{el.name}}</th>
                          <td>{{el.percent}} %</td>
                          <td :style="'color:'+el.color">
                            {{el.sd}}
                            <span v-html="el.icon"></span>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-lg-8 plotReport3">
                <div id="keyinReport">
                  <div class="card">
                    <div class="card-title pr d-flex" data-group="tableTitle">
                      <span>每時段已KEY單件數</span>
                      <div class="Calendar">
                        <div class="switch">
                          <input
                            type="radio"
                            class="switch-input"
                            name="hrKeyin"
                            id="hrKeyin-1"
                            value="month"
                            v-model="hrKeyin"
                            @change="getKeyinDataPrev"
                          />
                          <label for="hrKeyin-1" class="switch-label switch-label-off">單月</label>
                          <input
                            type="radio"
                            class="switch-input"
                            name="hrKeyin"
                            id="hrKeyin-2"
                            value="date"
                            v-model="hrKeyin"
                            checked
                            @change="getKeyinDataPrev"
                          />
                          <label for="hrKeyin-2" class="switch-label switch-label-on">單日</label>
                          <span class="slider"></span>
                        </div>
                        <div
                          class="form-check form-check-inline hrKeyin"
                          data-val="month"
                          v-if="hrKeyin == 'month'"
                        >
                          <select
                            class="form-control calendarSel"
                            v-model="hrKeyinObj.sel"
                            @change="getKeyinDataPrev"
                          >
                            <option
                              :value="String(mon).padStart(2, '0')"
                              v-for="mon in 12"
                              :key="mon"
                            >{{mon}} 月</option>
                          </select>
                        </div>
                        <div
                          class="form-check form-check-inline hrKeyin"
                          data-val="date"
                          v-if="hrKeyin == 'date'"
                        >
                          <input
                            type="date"
                            class="form-control calendarInput"
                            v-model="hrKeyinObj.input"
                            @change="getKeyinDataPrev"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <div>
                        <canvas id="keyinPerhour"></canvas>
                      </div>
                    </div>
                  </div>
                </div>
            </div>-->
            <!-- <div class="col-lg-4 plotReport4">
                <div id="WebRejectToOffline">
                  <div class="card">
                    <div class="card-title pr d-flex" data-group="tableTitle">
                      <span>退線下原因</span>
                      <div class="Calendar">
                        <div class="switch">
                          <input
                            type="radio"
                            class="switch-input"
                            name="WebRejectToOffline"
                            id="WRTO-1"
                            value="month"
                            v-model="WRTO"
                            @change="getWRTOPrev"
                          />
                          <label for="WRTO-1" class="switch-label switch-label-off">單月</label>
                          <input
                            type="radio"
                            class="switch-input"
                            name="WebRejectToOffline"
                            id="WRTO-2"
                            value="date"
                            v-model="WRTO"
                            checked
                            @change="getWRTOPrev"
                          />
                          <label for="WRTO-2" class="switch-label switch-label-on">單日</label>
                          <span class="slider"></span>
                        </div>
                        <div
                          class="form-check form-check-inline WRTO"
                          data-val="month"
                          v-if="WRTO == 'month'"
                        >
                          <select
                            class="form-control calendarSel"
                            v-model="WRTOobj.sel"
                            @change="getWRTOPrev"
                          >
                            <option
                              :value="String(mon).padStart(2, '0')"
                              v-for="mon in 12"
                              :key="mon"
                            >{{mon}} 月</option>
                          </select>
                        </div>
                        <div
                          class="form-check form-check-inline WRTO"
                          data-val="date"
                          v-if="WRTO == 'date'"
                        >
                          <input
                            type="date"
                            class="form-control calendarInput"
                            v-model="WRTOobj.input"
                            @change="getWRTOPrev"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <div>
                        <canvas id="plotWRTO"></canvas>
                      </div>
                    </div>
                  </div>
                </div>
            </div>-->
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mainDep: "",
      weekAry: [],
      hrKeyin: "date",
      WRTO: "date",
      webExamSel: "",
      convertSel: "0",
      convertData: [],
      hrKeyinObj: {
        input: "",
        sel: ""
      },
      WRTOobj: {
        input: "",
        sel: ""
      },
      handler: {
        plotKeyinDataReq: "",
        plotWebRejectToOfflineReq: ""
      }
    };
  },
  props: {
    time: {
      type: Object,
      required: true
    },
    mainColorObj: {
      type: Object,
      required: true
    }
  },
  created() {
    this.mainDep = this.$route.params.dep;
  },
  mounted() {
    this.getWeekAry();
  },
  computed: {
    mainData() {
      return this.$store.state.mainData[`${this.mainDep}`];
    }
  },
  methods: {
    getWeekAry() {
      this.weekAry = [
        [
          "2019-12-01",
          "2019-12-02",
          "2019-12-03",
          "2019-12-04",
          "2019-12-05",
          "2019-12-06"
        ]
      ];
      this.webExamSel = 0;
    },
    getWebExamData() {
      let thisFullWeek = this.weekAry[this.webExamSel];
      let label = thisFullWeek,
        datasets = [],
        datas = [],
        obj = {};
      thisFullWeek.forEach(el => {
        let web = this.mainData[el]
          ? ((this.mainData[el].web / this.mainData[el].total) * 100).toFixed(2)
          : 0;
        datas.push(web);
      });
      obj = {
        data: datas,
        borderColor: this.mainColorObj[this.mainDep].color,
        backgroundColor: this.mainColorObj[this.mainDep].color,
        label: `線上通路`,
        fill: false
      };
      datasets.push(obj);
      (datas = []), (obj = {});
      thisFullWeek.forEach(el => {
        let offline = this.mainData[el]
          ? (
              (this.mainData[el].offline / this.mainData[el].total) *
              100
            ).toFixed(2)
          : 0;
        datas.push(offline);
      });
      obj = {
        data: datas,
        borderColor: "lightgrey",
        // backgroundColor: 'lightgrey',
        borderDash: [10, 5],
        label: `線下通路`,
        fill: false
      };
      datasets.push(obj);
      let options = {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                steps: 10,
                stepValue: 5,
                max: 100,
                callback(label) {
                  return Math.floor(label) + "%";
                }
              }
            }
          ]
        },
        steppedLine: true,
        tooltips: {
          mode: "label",
          position: "nearest"
        }
      };
      let plotObj = {
        domID: "WebReportDataPlot",
        label: label,
        datasets: datasets,
        options: options,
        destroyTrigger: ["#page1CalendarSel@change"]
      };
      plotChart(plotObj, "line");
    },
    getConvertData() {
      this.convertData = [];
      let thisFullWeek = this.weekAry[this.convertSel];
      let label = ["錯誤件數", "正確件數", "瑕疵件數"];
      let success = 0,
        fail = 0,
        wrong = 0,
        total = 0;
      for (let i in this.mainData) {
        success += this.mainData[i].convert_success;
        fail += this.mainData[i].convert_fail;
        wrong += this.mainData[i].convert_wrong;
        total += this.mainData[i].total;
      }
      success = ((success / total) * 100).toFixed(2);
      fail = ((fail / total) * 100).toFixed(2);
      wrong = ((wrong / total) * 100).toFixed(2);

      let plotObj = {
        domID: "convertStatPlot",
        label: label,
        datasets: [
          {
            data: [fail, success, wrong],
            backgroundColor: ["#EFA2A9", "#D1ECF1", "#E2E3E5"]
          }
        ],
        options: {
          responsive: true
        },
        destroyTrigger: ["#page1CalendarSel2@change"]
      };
      plotChart(plotObj, "pie");
    }
  },
  watch: {
    mainData: function(newVal, oldVal) {
      this.getWebExamData();
      this.getConvertData();
    }
  }
};
function plotChart(Obj, plotType) {
  let ctx = document.getElementById(Obj.domID);
  if (!ctx) return;
  ctx = ctx.getContext("2d");
  let chart = new Chart(ctx, {
    type: plotType,
    responsive: true,
    data: {
      labels: Obj.label,
      datasets: Obj.datasets
    },
    options: Obj.options
  });

  Obj.destroyTrigger.forEach(el => {
    let dom = el.split("@")[0];
    let action = el.split("@")[1];
    $(`${dom}`).one(`${action}`, function() {
      chart.destroy();
      // chart.update();
    });
  });
}

function getFristTimeAndLastTime(ary) {
  let { hr: first } = ary.reduce(
    (prev, next) => {
      next.hr = next.hr * 1;
      next.hr >= 8 && next.hr < prev.hr
        ? (prev.hr = next.hr)
        : (prev.hr = prev.hr);
      return prev;
    },
    { hr: 13 }
  );

  let { hr: last } = ary.reduce(
    (prev, next) => {
      prev.hr < 8 && next.hr < 8
        ? (prev.hr = next.hr)
        : prev.hr < 8
        ? (prev.hr = prev.hr)
        : (prev.hr = next.hr);
      return prev;
    },
    { hr: 23 }
  );

  return [first, last];
}
</script>